import { Modal } from 'antd';
import { useCallback, useState } from 'react';
import StoreSelector from './StoreSelector';

const StoreSelectorModal = () => {
  const [open, setOpen] = useState(true);

  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      footer={null}
      centered
      destroyOnClose
      title="Select Store"
      closable={false}
      maskClosable={false}
    >
      <StoreSelector onSubmit={closeModal} />
    </Modal>
  );
};

export default StoreSelectorModal;
